var TOUR = require('../../common/tours/example');
var Promise = require('bluebird');

module.exports = function($scope, Tour, $state){
  var vm = this;

  vm.start = function(){
    Tour.Start(TOUR);
  }

  vm.next = function(){
    $state.go('public.tour-two')
  }


}
